import {AxiosResponse} from "axios";
import {BaseQueryOptions, BaseUseQueryResult, useBaseQuery} from "@bounce/shared/requests";
import {axiosReachInstance} from "../../ReachApiManager";
import {AUDIENCES_QUERY_KEY} from "../queryKeys";
import {AudienceRow} from "./types";

type Data = AudienceRow[];

const getAudiences = async (): Promise<Data> => {
  const response = await axiosReachInstance.get<Data, AxiosResponse<Data>>("/audiences");
  return response.data;
};

export const useGetAudiences = (options?: BaseQueryOptions<Data, void>): BaseUseQueryResult<Data> => {
  return useBaseQuery<Data, void>([AUDIENCES_QUERY_KEY], getAudiences, undefined, options);
};
